

export class HomepageLink{
    constructor(){
        this.url = "";
        this.text = ""
        this.icon = "running";
    }
}